// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  max-width: var(--page-max);
  margin: 0 auto;
  padding: 2.25rem 1.5rem 4rem;
}

.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

/* Einstieg: links Titel, rechts zwei Wege */
.home-intro {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 2rem 3rem;
  align-items: end;
  padding-bottom: 2rem;
  margin-bottom: 1.75rem;
  border-bottom: 1px solid var(--border-primary);
}

.home-intro-text {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.6rem;
}

.home-intro h1 {
  margin: 0;
  font-size: clamp(2.3rem, 6vw, 3.6rem);
}

.home-intro-text p {
  margin: 0;
  max-width: 38rem;
  font-size: 1.08rem;
}

.home-paths {
  display: grid;
  border-top: 2px solid var(--text-primary);
}

.home-path {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 3.6rem;
  padding: 0.7rem 0;
  border-bottom: 1px solid var(--border-primary);
  color: var(--text-primary);
}

.home-path:hover {
  color: var(--accent-primary);
}

.home-path > svg {
  flex-shrink: 0;
  color: var(--accent-primary);
}

.home-path-title {
  display: block;
  font-family: var(--font-display);
  font-size: 1.35rem;
  font-weight: 600;
  text-transform: uppercase;
  line-height: 1.1;
}

.home-path-text {
  display: block;
  font-size: 0.88rem;
  color: var(--text-secondary);
}

/* Beworbenes Produkt */
.home-promoted {
  display: block;
  margin-bottom: 2rem;
  border: 1px solid var(--border-primary);
  overflow: hidden;
}

.home-promoted img {
  display: block;
  width: 100%;
  height: auto;
}

/* Filter */
.home-products {
  scroll-margin-top: calc(var(--header-height) + 1rem);
}

.home-products-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1.5rem;
  margin-bottom: 1.25rem;
}

.home-filter {
  grid-template-columns: repeat(3, auto);
  margin: 0;
}

.home-filter button {
  padding-inline: 1.1rem;
}

.home-count {
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.home-dimmed-hint {
  margin: -0.25rem 0 1.25rem;
  font-size: 0.92rem;
  color: var(--text-secondary);
}

/* Produktkarten: ohne Kartenrahmen, Uhr auf Zifferblatt-Grund */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 15rem), 1fr));
  gap: 2rem 1.25rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.product-card {
  min-width: 0;
  transition: opacity 0.3s ease, filter 0.3s ease;
}

.product-card.dimmed {
  opacity: 0.38;
  filter: grayscale(0.8);
}

.product-card.dimmed:hover,
.product-card.dimmed:focus-within {
  opacity: 0.85;
  filter: none;
}

.product-card-link {
  display: grid;
  gap: 0.5rem;
  color: var(--text-primary);
}

.product-card-link:hover {
  color: var(--text-primary);
}

.card-dial {
  display: grid;
  place-items: center;
  aspect-ratio: 1;
  max-width: 100%;
  overflow: hidden;
}

.card-dial img {
  position: relative;
  display: block;
  width: 96%;
  height: auto;
}

.card-dial img {
  transition: transform 0.6s cubic-bezier(0.3, 0.7, 0.2, 1);
}

.product-card-link:hover .card-dial img,
.product-card-link:focus-visible .card-dial img {
  transform: scale(1.04);
}

.card-name {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  min-height: 1.3rem;
}

.card-spec {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem 0.75rem;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 820px) {
  .home-intro {
    grid-template-columns: minmax(0, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 680px) {
  .home-page {
    padding: 1.5rem 1rem 3rem;
  }

  .product-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem 0.9rem;
  }

  .card-name {
    font-size: 1.2rem;
  }

  .home-filter {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sDAAsD;EACtD,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,WAAW;AACX;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,uEAAuE;EACvE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,qCAAqC;EACvC;AACF","sourcesContent":[".home-page {\n  max-width: var(--page-max);\n  margin: 0 auto;\n  padding: 2.25rem 1.5rem 4rem;\n}\n\n.visually-hidden {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n/* Einstieg: links Titel, rechts zwei Wege */\n.home-intro {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\n  gap: 2rem 3rem;\n  align-items: end;\n  padding-bottom: 2rem;\n  margin-bottom: 1.75rem;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.home-intro-text {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.6rem;\n}\n\n.home-intro h1 {\n  margin: 0;\n  font-size: clamp(2.3rem, 6vw, 3.6rem);\n}\n\n.home-intro-text p {\n  margin: 0;\n  max-width: 38rem;\n  font-size: 1.08rem;\n}\n\n.home-paths {\n  display: grid;\n  border-top: 2px solid var(--text-primary);\n}\n\n.home-path {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  min-height: 3.6rem;\n  padding: 0.7rem 0;\n  border-bottom: 1px solid var(--border-primary);\n  color: var(--text-primary);\n}\n\n.home-path:hover {\n  color: var(--accent-primary);\n}\n\n.home-path > svg {\n  flex-shrink: 0;\n  color: var(--accent-primary);\n}\n\n.home-path-title {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  line-height: 1.1;\n}\n\n.home-path-text {\n  display: block;\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n\n/* Beworbenes Produkt */\n.home-promoted {\n  display: block;\n  margin-bottom: 2rem;\n  border: 1px solid var(--border-primary);\n  overflow: hidden;\n}\n\n.home-promoted img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n/* Filter */\n.home-products {\n  scroll-margin-top: calc(var(--header-height) + 1rem);\n}\n\n.home-products-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.home-filter {\n  grid-template-columns: repeat(3, auto);\n  margin: 0;\n}\n\n.home-filter button {\n  padding-inline: 1.1rem;\n}\n\n.home-count {\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-tertiary);\n}\n\n.home-dimmed-hint {\n  margin: -0.25rem 0 1.25rem;\n  font-size: 0.92rem;\n  color: var(--text-secondary);\n}\n\n/* Produktkarten: ohne Kartenrahmen, Uhr auf Zifferblatt-Grund */\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 15rem), 1fr));\n  gap: 2rem 1.25rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.product-card {\n  min-width: 0;\n  transition: opacity 0.3s ease, filter 0.3s ease;\n}\n\n.product-card.dimmed {\n  opacity: 0.38;\n  filter: grayscale(0.8);\n}\n\n.product-card.dimmed:hover,\n.product-card.dimmed:focus-within {\n  opacity: 0.85;\n  filter: none;\n}\n\n.product-card-link {\n  display: grid;\n  gap: 0.5rem;\n  color: var(--text-primary);\n}\n\n.product-card-link:hover {\n  color: var(--text-primary);\n}\n\n.card-dial {\n  display: grid;\n  place-items: center;\n  aspect-ratio: 1;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.card-dial img {\n  position: relative;\n  display: block;\n  width: 96%;\n  height: auto;\n}\n\n.card-dial img {\n  transition: transform 0.6s cubic-bezier(0.3, 0.7, 0.2, 1);\n}\n\n.product-card-link:hover .card-dial img,\n.product-card-link:focus-visible .card-dial img {\n  transform: scale(1.04);\n}\n\n.card-name {\n  font-family: var(--font-display);\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  min-height: 1.3rem;\n}\n\n.card-spec {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.2rem 0.75rem;\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 820px) {\n  .home-intro {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 680px) {\n  .home-page {\n    padding: 1.5rem 1rem 3rem;\n  }\n\n  .product-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1.5rem 0.9rem;\n  }\n\n  .card-name {\n    font-size: 1.2rem;\n  }\n\n  .home-filter {\n    width: 100%;\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
